<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: center;flex-direction: column;">

			<el-image style="width: 20rem; height: 20rem" :src="url" :preview-src-list="srcList">
			</el-image>
			<span>请使用微信扫一扫</span>
		</div>


		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		house_list,
		administrator_create,
		administrator_bind_wx_qrcode

	} from "@/api/api.js"
	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		data() {
			return {
				name: '',
				url: '',
				srcList: [],
				dialog_span: [{
					name: '账号',
					model: 'account'
				}, {
					name: '密码',
					model: 'password'
				}, {
					name: '姓名',
					model: 'name'
				}, {
					name: '电话',
					model: 'phone'
				}, {
					name: '邮箱',
					model: 'email'
				}],
				inputmodel: {
					account: '',
					password: '',
					name: '',
					phone: '',
					email: '',
					status: '1',
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10,
				},
			}
		},
		props: [
			"item"
		],
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							administrator_create(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			// 多选框
			changeselect(value) {
				// value 是被选中的房间号
				console.log('Selected room number:', value);
				// 你可以在这里根据 value 查找对应的 item，例如：
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.rid = selectedItem.id
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			// console.log('item:', this.item);
			administrator_bind_wx_qrcode({
				aid: this.item.id
			}).then(res => {
				const _res = res.data.dir
				this.url = _res;
				this.srcList = [_res]
			})
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				administrator_bind_wx_qrcode({
					aid: newVal.id
				}).then(res => {
					const _res = res.data.dir
					this.url = _res;
					this.srcList = [_res]
				})

			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>